<mat-dialog-content>
  <lib-image-list-picker [(ngModel)]="source">
    <lib-image-list-option
      data-vg="WatermarkAdvancedEditorTextOption"
      value="Text"
    >
      <label translate>clgmc8nqo000008mjb6zc4qgk</label>
      <mat-icon>title</mat-icon>
    </lib-image-list-option>
    <lib-image-list-option
      data-vg="WatermarkAdvancedEditorImageOption"
      value="Image"
    >
      <label translate>clgmc8w6z000108mjaqha1r8s</label>
      <mat-icon>image</mat-icon>
    </lib-image-list-option>
    <lib-image-list-option value="AntiAi">
      <label translate>clgmc8w6z000108mjaqha1r89</label>
      <mat-icon svgIcon="ai"></mat-icon>
    </lib-image-list-option>
  </lib-image-list-picker>

  @if (source === 'Text') {
    <lib-i18n-text-input [(ngModel)]="text"
      >{{ 'clgm4onbl000008mdezm8807s' | translate | async }}
    </lib-i18n-text-input>
    <div data-vg="WatermarkAdvancedEditorTextOpacity" translate>
      clgmcjm18000008lfext6gj0v
      <p>
        <input [(ngModel)]="opacity" max="1" min="0" step="0.01" type="range" />
      </p>
    </div>
    <p>
      <lib-checkbox
        [(ngModel)]="showLines"
        data-vg="WatermarkAdvancedEditorTextShowLines"
        translate
        >clgmclygo000108lf2fmy6p4q</lib-checkbox
      >
    </p>
    @if (showLines) {
      <div data-vg="WatermarkAdvancedEditorTextLinesOpacity" translate>
        clgmcm73k000208lfd74r1se0
        <p>
          <input
            [(ngModel)]="lineOpacity"
            max="1"
            min="0"
            step="0.01"
            type="range"
          />
        </p>
      </div>
    }
  }
  @if (source === 'Image') {
    <app-watermark-file-management
      [(ngModel)]="fileName"
    ></app-watermark-file-management>
    <input [(ngModel)]="opacity" max="1" min="0" step="0.01" type="range" />
  }
  @if (source !== 'AntiAi') {
    <p>
      <mat-form-field
        libZalamoField
        data-vg="WatermarkAdvancedEditorWatermarkType"
      >
        <mat-label translate>clgmcmib5000308lfd7e5bzhe</mat-label>
        <mat-select [(ngModel)]="mode">
          <mat-option value="Single" translate
            >clgmcmwm7000408lf7iedd0xn</mat-option
          >
          <mat-option value="Multi" translate
            >clgmcn3bo000508lfeq72cqiz</mat-option
          >
          @if (source === 'Image') {
            <mat-option value="Custom" translate
              >clgmcn9bc000608lfaag85tjh
            </mat-option>
          }
        </mat-select>
        <lib-zalamo-field-decoration></lib-zalamo-field-decoration
      ></mat-form-field>
    </p>
    @if (mode !== 'Custom' || source === 'Text') {
      <app-watermark-preview
        [fileName]="fileName"
        [lineOpacity]="lineOpacity"
        [mode]="mode"
        [opacity]="opacity"
        [showLines]="showLines"
        [source]="source"
        [text]="text"
        data-vg="WatermarkAdvancedEditorWatermarkPreview"
      ></app-watermark-preview>
    } @else {
      <app-watermark-universal-inline-picker [(ngModel)]="customConfig">
      </app-watermark-universal-inline-picker>
    }
  } @else {
    <ol>
      @if (context === publicSessionContext) {
        <li>
          Darmowa wersja dla sesji do
          {{ publicSessionFreeAntiAiPhotosCount }} zdjęć. Każde kolejne
          {{ publicSessionAntiAiPhotosPerSession }} zdjęć - koszt jedna sesja
        </li>
      }
      <li>
        Nie dajemy gwarancji, że nie pojawi się nowe AI, które poradzi sobie z
        tym znakiem
      </li>
      <li>Zdjęcia mogą się dłużej ładować</li>
    </ol>
    <h1>Poziom intensywności</h1>
    <lib-image-list-picker [(ngModel)]="aiLevel">
      <lib-image-list-option value="1">
        <img src="/assets/icons/level1.svg" />
      </lib-image-list-option>
      <lib-image-list-option
        data-vg="WatermarkAdvancedEditorImageOption"
        value="2"
      >
        <img src="/assets/icons/level2.svg" />
      </lib-image-list-option>
    </lib-image-list-picker>
    <div class="aiPreview">
      @switch (aiLevel) {
        @case ('1') {
          <img src="/assets/images/antiAI1.jpg" />
        }
        @case ('2') {
          <img src="/assets/images/antiAI2.jpg" />
        }
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <lib-button (click)="save()" forceContext="common" translate>save</lib-button>
  <lib-button mat-dialog-close forceContext="common" translate
    >cancel</lib-button
  >
</mat-dialog-actions>
